import React, { useEffect, useState } from "react"
import {
  View,
  Text,
  FlatList,
  TouchableOpacity,
  StyleSheet,
  Platform
} from "react-native"
import Feather from "@expo/vector-icons/Feather"
import moment from "moment"
import IssueDetailsModal from "../../../components/maintainance/IssueDetailsModal"
import { maintenanceService } from "../../../redux/action/maintenance.service"
import AddNewIssueModal from "../../../components/maintainance/AddNewIssueModal"
import SelfManageModal from "../../../components/maintainance/SelfManageModal"
import { navigate } from "../../../navigation/RootNavigation"
import { showSuccesToast } from "../../tenants/tenantOnboarding/helpers"
import { COLORS } from "../../tenants/tenantOnboarding/screens/components/PropertyDetailsCard"
import { Pagination } from "@mui/material"
import CommonModal from "../../../components/maintainance/CommonModal"

interface Props {
  flos?: any[]
  onView: (row: any) => void;
  refresh:(row: any) => void;
  editView:(row: any) => void;
  onSelfManageSuccess:() => void;
  slelfManageCallback:boolean;
  handlePageChange:() => void;
  pageCount:any;
  page:any;
  openflow_id:any
}

function NewIssueTable({ flos = [] ,refresh,editView,openflow_id,slelfManageCallback,onSelfManageSuccess,pageCount,page,handlePageChange}: Props) {

  const [list, setList] = useState<any[]>([])
  const [selected, setSelected] = useState<number[]>([])
  const [selectedIssue, setSelectedIssue] = useState(null)
  const [openModal, setOpenModal] = useState(false)
  const [loader, setLoader] = useState(false)
  const [openquote, setOpenQuote] = useState(false)



const [openSelfManage, setOpenSelfManage] = useState(false)
const [selectedIssues, setSelectedIssues] = useState<any[]>([])

  const handleView = (issue) => {
    setSelectedIssue(issue)
    setOpenModal(true)
  }
  useEffect(() => {
    setList(flos || [])
  }, [flos])

  /* ---------------- SELECTION ---------------- */

  const toggleSelect = (id: number) => {
    if (selected.includes(id)) {
      setSelected(selected.filter(i => i !== id))
    } else {
      setSelected([...selected, id])
    }
  }

  const toggleSelectAll = () => {
    if (selected.length === list.length) {
      setSelected([])
    } else {
      setSelected(
        list.map(i => i.open_flow_maintenance_issue_id)
      )
    }
  }

  const isAllSelected =
    selected.length === list.length && list.length > 0

  /* ---------------- RENDER ---------------- */
  const handleSelfManage = () => {
    const filtered = list.filter(issue =>
      selected.includes(issue.open_flow_maintenance_issue_id)
    )
  
    setSelectedIssues(filtered)
    setOpenSelfManage(true)
  }
  const handlePageChanges = (event, value) => {
    handlePageChange(value)
  }
  return (
    <View style={{ flex: 1 }}>
 {selected.length > 0 && (
        <View style={styles.bottomBar}>

          <Text style={styles.selectedCount}>
            {selected.length} Selected
          </Text>

          <View style={{ flexDirection: "row", gap: 15 }}>

            <TouchableOpacity 
            onPress={()=>setOpenQuote(true)}
            style={styles.quoteBtn}>
              <Text style={styles.quoteText}>
              Get Quote
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.manageBtn}
              disabled={selected.length === 0}
              onPress={handleSelfManage}

            >
              <Text style={styles.manageText}>
                Self Manage
              </Text>
            </TouchableOpacity>

          </View>

        </View>
      )}
      <View style={styles.tableCard}>

  
       
        <View style={styles.headerRow}>

          <View style={styles.colCheckbox}>
            <TouchableOpacity onPress={toggleSelectAll}>
              <Feather
                name={isAllSelected ? "check-square" : "square"}
                size={18}
                color="#7C3AED"
              />
            </TouchableOpacity>
          </View>

          <View style={styles.colStatus}>
            <Text style={styles.headerText}>STATUS</Text>
          </View>

          <View style={styles.colTitle}>
            <Text style={styles.headerText}>TITLE</Text>
          </View>

          <View style={styles.colDate}>
            <Text style={styles.headerText}>DATE</Text>
          </View>

          <View style={styles.colCategory}>
            <Text style={styles.headerText}>CATEGORY</Text>
          </View>

          <View style={styles.colRoom}>
            <Text style={styles.headerText}>ROOM</Text>
          </View>

          <View style={styles.colReported}>
            <Text style={styles.headerText}>REPORTED BY</Text>
          </View>

          <View style={styles.colActions}>
            <Text style={styles.headerText}>ACTIONS</Text>
          </View>

        </View>

        {/* ROWS */}
        <FlatList
          data={list}
          keyExtractor={(item) =>
            item.open_flow_maintenance_issue_id.toString()
          }
          extraData={selected}
          renderItem={({ item }) => {

            const id = item.open_flow_maintenance_issue_id
            const isSelected = selected.includes(id)
            console.log("isSelected",selected)
            console.log("isSelected",isSelected)

            console.log("isSelected id",id)

            const status =
              item.status === "pending" ? "NEW" : item.status

            const category =
              item.open_flow_maintenance_issue_category?.name || "—"

            const room =
              item.open_flow_maintenance_issue_room_type?.name || "—"

            const reportedBy =
              `${item.user?.first_name || ""} ${item.user?.last_name || ""}`

            return (
              <View style={styles.row}>

                {/* CHECKBOX */}
                <View style={styles.colCheckbox}>
                  <TouchableOpacity
                    onPress={() => toggleSelect(id)}
                  >
                    <Feather
                      name={isSelected ? "check-square" : "square"}
                      size={18}
                      color="#7C3AED"
                    />
                  </TouchableOpacity>
                </View>

                {/* STATUS */}
                <View style={styles.colStatus}>
                  <View style={styles.statusBadge}>
                    <Text style={styles.statusText}>
                      {status}
                    </Text>
                  </View>
                </View>

                {/* TITLE */}
                <View style={styles.colTitle}>
                  <Text
                    style={styles.cell}
                    numberOfLines={2}
                  >
                    {item.title || "Untitled"}
                  </Text>
                </View>

                {/* DATE */}
                <View style={styles.colDate}>
                  <Text style={styles.cell}>
                    {moment(item.date_opened).format("DD MMM YYYY")}
                  </Text>
                </View>

                {/* CATEGORY */}
                <View style={styles.colCategory}>
                  <Text
                    style={styles.cell}
                    numberOfLines={2}
                  >
                    {category}
                  </Text>
                </View>

                {/* ROOM */}
                <View style={styles.colRoom}>
                  <Text
                    style={styles.cell}
                    numberOfLines={2}
                  >
                    {room}
                  </Text>
                </View>

                {/* REPORTED BY */}
                <View style={styles.colReported}>
                  <Text
                    style={styles.reportName}
                    numberOfLines={1}
                  >
                    {reportedBy}
                  </Text>
                  <Text
                    style={styles.reportEmail}
                    numberOfLines={1}
                  >
                    {item.user?.email}
                  </Text>
                </View>

                {/* ACTIONS */}
                <View style={styles.colActions}>
                  <TouchableOpacity 
                  onPress={() => editView(item)}
                  style={styles.editBtn}>
                    <Text style={styles.editText}>
                      EDIT
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.viewBtn}
                    onPress={() => handleView(item)}
                  >
                    <Text style={styles.viewText}>
                      VIEW
                    </Text>
                  </TouchableOpacity>
                </View>

              </View>
            )
          }}
        />

      </View>
      <Pagination 
      style={{alignSelf:"center",marginTop:10}}
      count={pageCount} page={page} onChange={handlePageChanges} color='primary' />
      {/* BOTTOM ACTION BAR */}
      {selected.length > 0 && (
        <View style={styles.bottomBar}>

          <Text style={styles.selectedCount}>
            {selected.length} Selected
          </Text>

          <View style={{ flexDirection: "row", gap: 15 }}>

            <TouchableOpacity 
               onPress={()=>setOpenQuote(true)}
            style={styles.quoteBtn}>
              <Text style={styles.quoteText}>
              Get Quote
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.manageBtn}
              disabled={selected.length === 0}
              onPress={handleSelfManage}
            >
              <Text style={styles.manageText}>
                Self Manage
              </Text>
            </TouchableOpacity>

          </View>

        </View>
      )}


<IssueDetailsModal
  open={openModal}
  issue={selectedIssue}
  loader={loader}
  onClose={() => setOpenModal(false)}
  onSummarize={ async (issue) => {
    setLoader(true)
    console.log('issue',issue)
    const data = await maintenanceService.summarizeRequest(issue.open_flow_maintenance_issue_id)
    setLoader(false)
    console.log("Summarize data", data)
    setOpenModal(false)
    refresh(true)

  }}
/>
<SelfManageModal
  visible={openSelfManage}
  issues={selectedIssues}
  loader={loader}
  onClose={() => setOpenSelfManage(false)}
  onRemove={(id) => {
    // remove from parent selection
    setSelected(prev =>
      prev.filter(itemId => itemId !== id)
    )
  }}
  onConfirm={ async (payload) => {
    console.log("FINAL PAYLOAD:", payload)
  let payload2=  {
      "title": payload.title,
      "issue_ids":payload.issue_ids
  }
    setLoader(true)
 

    const data = await maintenanceService.createProject(openflow_id,payload2)
    setLoader(false)
    console.log("Summarize data", data)
    showSuccesToast("Project created successfully!")
    setOpenModal(false)
    refresh(true)
    setOpenSelfManage(false)
    if(slelfManageCallback){
      onSelfManageSuccess()
    }else{
      navigate('ActiveProjects', {
        id: data?.data?.open_flow_maintenance_project_id
      })
    }
   
  }}
/>
<CommonModal
        visible={openquote}
        heading="Coming soon!"
        subheading={ ""}
        yesText={"ok"}
        noText=""
        onYes={() => setOpenQuote(false)}
      
      />
    </View>
  )
}

export default NewIssueTable

const styles = StyleSheet.create({

    tableCard: {
      backgroundColor: "#fff",
      borderRadius: 16,
      paddingVertical: 20,
      shadowColor: "#000",
      shadowOpacity: 0.08,
      shadowRadius: 12,
      elevation: 3,
      marginTop:10
    },
  
    headerRow: {
      flexDirection: "row",
      alignItems: "center",
      paddingBottom: 15,
      borderBottomWidth: 1,
      borderColor: "#E5E7EB",
    },
  
    headerText: {
      fontSize: 12,
      fontWeight: "700",
      color: "#6B7280",
    },
  
    row: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 14,
      borderBottomWidth: 1,
      borderColor: "#F3F4F6",
    },
  
    /* FIXED COLUMN WIDTHS */
    colCheckbox: { flex: 0.5, alignItems: "center" },
    colStatus: { flex: 0.8 },
    colTitle: { flex: 1.5 },
    colDate: { flex: 1 },
    colCategory: { flex: 1 },
    colRoom: { flex: 0.8 },
    colReported: { flex: 1.8 },
    colActions: {
      flex: 1.6,
      alignItems: "flex-end",
      marginRight:20,
      
    },
  
    cell: {
      fontSize: 13,
      color: "#374151",
      lineHeight: 18,
    },
  
    reportName: {
      fontWeight: "600",
      fontSize: 13,
      color: "#374151",
    },
  
    reportEmail: {
      fontSize: 12,
      color: "#9CA3AF",
    },
  
    statusBadge: {
      borderWidth: 1,
      borderColor: "#EF4444",
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 12,
      alignSelf: "flex-start",
    },
  
    statusText: {
      color: "#EF4444",
      fontWeight: "600",
      fontSize: 11,
    },
  
    editBtn: {
      borderWidth: 1,
      borderColor: "#EC4899",
      paddingVertical: 10,
      paddingHorizontal: 14,
      borderRadius: 20,
      alignItems:"center",
      width:130
    },
  
    editText: {
      color: "#EC4899",
      fontWeight: "600",
      fontSize: 12,
    },
  
    viewBtn: {
      backgroundColor: COLORS.primary,
      paddingVertical: 10,
      paddingHorizontal: 14,
      borderRadius: 20,
       alignItems:"center",
       marginTop:10,
       width:130
    },
  
    viewText: {
      color: "#fff",
      fontWeight: "600",
      fontSize: 12,
    },
  
    bottomBar: {
    marginTop:10,
      backgroundColor: "#fff",
      padding: 20,
      borderTopWidth: 1,
      borderColor: "#E5E7EB",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: 16,
    },
  
    selectedCount: {
      fontWeight: "600",
      color: "#6D08C0",
    },
  
    quoteBtn: {
      borderWidth: 1,
      borderColor: "#6D08C0",
      paddingVertical: 8,
      paddingHorizontal: 18,
      borderRadius: 30,
    },
  
    quoteText: {
      color: "#6D08C0",
      fontWeight: "600",
    },
  
    manageBtn: {
      backgroundColor: "#6D08C0",
      paddingVertical: 8,
      paddingHorizontal: 18,
      borderRadius: 30,
    },
  
    manageText: {
      color: "#fff",
      fontWeight: "600",
    },
  
  })
  